var map = {
	"./AQA-74472-JUN22-questions.json": 3014,
	"./AQA-74472-JUN23-questions.json": 4617,
	"./AQA-74472-JUN24-questions.json": 4528,
	"./AQA-74472-NOV20-questions.json": 4214,
	"./AQA-74472-NOV21-questions.json": 7929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5076;